module.exports = __webpack_public_path__ + "static/media/green-add-vehicle.f9c86eea.svg";